module.exports = __webpack_public_path__ + "sc.fa4701b92718cc67e529.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sc.svg
// module chunks = styles